export const RightCapitalHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Create new or link to RightCapital contacts from your meetings and emails</li>
        <li>Easily create or update Contacts, Family, Goals, Incomes, and Expenses in RightCapital with insights from your meetings and emails</li>
      </ul>
    </div>
  )
}
